/* eslint-disable import/prefer-default-export */
import { ModelData } from 'bloko/common/tree/types';

export const data: ModelData[] = [
    {
        id: '113',
        text: 'Россия',
        items: [
            { id: '1', text: 'Москва' },
            {
                id: '1217',
                text: 'Алтайский край',
                items: [
                    { id: '11', text: 'Барнаул' },
                    { id: '1220', text: 'Бийск' },
                ],
            },
        ],
    },
    {
        id: '16',
        text: 'Беларусь',
        items: [{ id: '1007', text: 'Брест' }],
    },
];

export const dataDuplicate: ModelData[] = [
    {
        id: 'category-1',
        text: 'Продажи, обслуживание клиентов',
        selected: true,
        items: [
            {
                id: '10',
                text: 'Аналитик',
            },
            {
                id: '40',
                text: 'Другое',
            },
            {
                id: '49',
                text: 'test',
            },
        ],
    },
    {
        id: 'category-2',
        text: 'Розничная торговля',
        items: [
            {
                id: '9',
                text: 'Администратор магазина, администратор торгового зала',
            },
            {
                id: '97',
                text: 'Продавец-консультант, продавец-кассир',
            },
        ],
    },
    {
        id: 'category-4',
        text: 'Стратегия, инвестиции, консалтинг',
        items: [
            {
                id: '10',
                text: 'Аналитик',
            },
            {
                id: '40',
                text: 'Другое',
            },
            {
                id: '75',
                text: 'Менеджер/консультант по стратегии',
            },
        ],
    },
];
